import { useAtom, useGet, getFocus } from "state/jotai";
import { _isometry } from "state/store.isometry";
import { isMulti_project_active } from "state/store.global";
import { useLocation, useParams } from "react-router-dom";
import { IFrameNav, Nav, NavContainer } from "./TopMenu.style";
import { useBreak } from "hooks/useBreak";
import NavItems from "components/Nav/NavItems";
import { iso_free, active_project } from "state/store.global";
import styled from "styled-components/macro";
import { BREAK_ } from "constants";
import { _project } from "state/store.projects";
import { current_language } from "state/store.global";
import { _bootstrap } from "state/store.bootstrap";
import { LogoWrap } from "components/Nav/Nav.Desktop.style";
import { Logo } from "components/Nav/Nav.Logo";
import { NavDesktop } from "components/Nav/Nav.Desktop";
import { useEffect, useState, useMemo } from "react";
import { BackButton } from "components/Button/BackButton";
import { isIframeMode } from "logging/logging";
import { OverviewBack } from "components/Isometry/OverviewBack";

export const TopMenu = ({ left, right, nav }) => {
  const rmode = useAtom(iso_free)[0];
  const isDesktop = useBreak("md_up");

  const multiActive = useAtom(isMulti_project_active)[0];
  const here = useLocation().pathname;
  const { pin, pid } = useGet(active_project);
  const [currentLanguage] = useAtom(current_language);
  const [face, setFace] = useState("");

  const buttonsLabel = getFocus(_project, "buttonsLabel")?.[pin]?.[pid] ?? [];
  const projectType = getFocus(_bootstrap, "type");
  const dropdownOptions = getFocus(_bootstrap, "projectnames");
  const menus = getFocus(_project, "menuItems")?.[pin]?.[pid] ?? [];

  const menuItemOrder10 = menus.find((item) => item.Order === "10");
  const logoUrl = menuItemOrder10?.URL ?? "https://soendrekyst.dk/";

  const routeChecks = useMemo(() => {
    const checks = {
      atModel: here.includes("isometry"),
      atList: here.includes("list"),
      atFavorites: here.includes("favorites"),
      atUnit: here.includes("unit"),
      atCompare: here.includes("compare"),
      atDownloads: here.includes("downloads"),
      atGallery: here.includes("gallery"),
    };
    
    checks.hidePropertyDropdownAtDesktop = ["unit", "downloads"].some((i) =>
      here.includes(i)
    );
    
    checks.hideFilterMultiActiveTrue = [
      "isometry", "compare", "gallery", "downloads", "unit"
    ].some((i) => here.includes(i));
    
    checks.hideFilterMultiActiveFalse = [
      "compare", "gallery", "downloads", "unit"
    ].some((i) => here.includes(i));
    
    checks.filterShouldShow = !multiActive
      ? !checks.hideFilterMultiActiveTrue
      : !checks.hideFilterMultiActiveFalse;
      
    return checks;
  }, [here, multiActive]);
const iFrameEnabled = isIframeMode();

 
  const isIsometry = here.includes("isometry");

  const IsList = here.includes("list");
  const showBackButton = isDesktop && (
    routeChecks.atCompare ||
    routeChecks.atFavorites ||
    routeChecks.atDownloads ||
    routeChecks.atGallery
  );

  const showPropertyDropdown = projectType === "poly" && 
    !routeChecks.hidePropertyDropdownAtDesktop && 
    !(rmode && !isDesktop);

  useEffect(() => {
    if (Object.keys(dropdownOptions).length && pid) {
      const selectedProject = dropdownOptions[currentLanguage]
        .filter((d, i) => d.PID === pid && i === pin)[0];
      setFace(selectedProject?.Presentation || "");
    }
  }, [pid, pin, currentLanguage, dropdownOptions]);


  if (!isDesktop) return null;
if (iFrameEnabled) {
    return (
      // Second return (currently active)
      <NavContainer>
        {isDesktop && (
          <IFrameNav clr={clr} left={left} right={right} nav={nav} pin={pin} layout>
            <>
              <span>
                {/* {isIsometry && <OverviewBack />} */}
                {!isIsometry && !IsList && (
                  <BackButton
                    applyClass={true}
                    style={{
                      position: "unset",
                      gap: "8px",
                      backgroundColor: "transparent",
                      padding: "8px",
                    }}
                    color={"#000"}
                  />
                )}
                {/* <LogoWrap style={{ paddingTop: "12px", paddingBottom: "12px" }}>
                <Logo device="desktop" key="desktopLogo" link="https://travbyen.dk/" />
              </LogoWrap> */}
              </span>
              {/* {isDesktop &&
(atCompare || atFavorites || atDownloads || atGallery) && (
                  <BackButton
                    color={
atUnit ? `${clr?.icons}` : `${clr?.primary_text_passive}`
}
/>
)} */}
              <span>
                {projectType === "poly" &&
                      !routeChecks.hidePropertyDropdownAtDesktop &&
                  !(rmode && !isDesktop) && (
                    <Face pin={pin} iFrameEnabled={iFrameEnabled}>
                      <span className="h4">
                      {buttonsLabel?.filter(
                        (btn) => btn.UILabelProperty === "CurrentlyViewing",
                      )[0]?.Label || "Du kigger lige nu på"}
                      </span>
                      {face === "Hele overview"
                        ? buttonsLabel?.filter(
                            (btn) => btn.UILabelProperty === "HeleOverview",
                          )[0]?.Label || face
                        : face}
                    </Face>
                  )}
              </span>
              <span>
                {/* {isDesktop && <NavItems hideNav={false} />} */}
                {/* {isDesktop && <NavDesktop />} */}
              </span>
            </>
            {/* )} */}
          </IFrameNav>
        )}
      </NavContainer>
    );
  }else{
 return (
    <Nav clr={clr} left={left} right={right} nav={nav} layout>
      <span>
        <LogoWrap style={{ paddingTop: "12px", paddingBottom: "12px" }}>
          <Logo device="desktop" key="desktopLogo" link={logoUrl} />
        </LogoWrap>
        
        {showBackButton && (
          <BackButton 
            color={routeChecks.atUnit ? clr?.icons : clr?.primary_text_passive}
          />
        )}
      </span>
      
      <span>
        {showPropertyDropdown && (
          <Face iFrameEnabled={iFrameEnabled}><span className="h4">Du kigger lige nu på:</span>&nbsp;{face}</Face>
        )}
      </span>
      
      <span>
        <NavItems hideNav={false} />
        <NavDesktop />
      </span>
    </Nav>
  );
  }
 
};

const Box = styled.div`
  gap: 5px;
  cursor: pointer;
  padding: 5px 15px;
  z-index: 5;
  align-items: center;
  display: flex;
  gap: 5px;
  user-select: none;
  ${BREAK_.md_up} {
    position: fixed;
    top: 92px;
    left: 48px;
    padding: 0;
  }
`;

const Text = styled.div`
  white-space: nowrap;
  color: ${({ clr, atUnit }) =>
    atUnit ? `${clr?.icons}` : `${clr?.primary_text_passive}`};
`;

export const Face = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
   color: ${({ pin, iFrameEnabled }) => (iFrameEnabled ? "#000" : "#FFF")};
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
`;
